import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import useProviderPackage from '@hooks/useProviderPackage'
import useProviderPackageItem from '@hooks/useProviderPackageItem'
import useProviderPackageItems from '@hooks/useProviderPackageItems'

import ProviderPackageProductListItem from './ProviderPackageProductListItem'

const ProviderPackageProducts = (props) => {
  const { providerPackageId } = props

  const providerPackagePayload = useProviderPackage({ id: providerPackageId })
  const { provider } = providerPackagePayload

  const {
    callbacks: {
      addProviderPackageItem,
    },
  } = useProviderPackageItem({ provider_id: provider.id, provider_package_id: providerPackageId })

  const providerPackageItemsPayload = useProviderPackageItems({
    filters: { provider_package_id: providerPackageId },
    performHttpRequests: !!providerPackageId,
    requestOptions: { include_provider_package_item_price_list: true },
  })

  const {
    filteredProviderPackageItems,
    hasFilteredProviderPackageItems,
    loading,
  } = providerPackageItemsPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} loading={loading} title="Products">
      <DashboardModule.ScrollableSection>
        {hasFilteredProviderPackageItems && filteredProviderPackageItems.map(providerPackageItem => (
          <ProviderPackageProductListItem
            key={providerPackageItem.id}
            providerPackageItem={providerPackageItem}
          />
        ))}

        {!loading && !hasFilteredProviderPackageItems && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Product Items
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please adjust your filters or add a product
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}
      </DashboardModule.ScrollableSection>

      <DashboardModule.Footer boxProps={{ borderTop: loading ? 'none' : '1px solid' }}>
        <DashboardModule.FooterRight>
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => addProviderPackageItem()}
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Product
          </Button>
        </DashboardModule.FooterRight>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

ProviderPackageProducts.propTypes = {
  providerPackageId: PropTypes.number.isRequired,
}

export default ProviderPackageProducts
